/**
 * Overlay dimension constants
 *
 * Centralized dimension values for trip list overlay components.
 * Eliminates magic numbers scattered across components.
 */

/**
 * Passport card dimensions for the carousel design.
 */
export const PASSPORT_CARD = {
  /** Width of a passport card in pixels */
  WIDTH: 280,
  /** Height of a passport card in pixels */
  HEIGHT: 392,
  /** Gap between cards in the carousel (px) */
  GAP: 32,
} as const

/**
 * Scroll distance for carousel navigation.
 * Equals card width + gap to ensure proper card centering.
 */
export const CAROUSEL_SCROLL_DISTANCE = PASSPORT_CARD.WIDTH + PASSPORT_CARD.GAP // 312
